import React from 'react';

const CoursePlatform = ({ className = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="75"
      height="75"
      x="0"
      y="0"
      viewBox="0 0 512 512"
      className={className}
    >
      <circle r="256" cx="256" cy="256" fill="#eae9f8" shape="circle" />
      <g transform="matrix(0.53,0,0,0.53,120.31999999999996,120.31999999999996)">
        <g xmlns="http://www.w3.org/2000/svg">
          <path
            d="M480,56H32A24.032,24.032,0,0,0,8,80V352a24.032,24.032,0,0,0,24,24H197.39l-11.42,40H152a8,8,0,0,0-8,8v16H80a8,8,0,0,0,0,16H432a8,8,0,0,0,0-16H368V424a8,8,0,0,0-8-8H326.03l-11.42-40H480a24.032,24.032,0,0,0,24-24V80A24.032,24.032,0,0,0,480,56ZM352,432v8H160v-8ZM202.61,416l11.42-40h83.94l11.42,40ZM488,352a8.011,8.011,0,0,1-8,8H32a8.011,8.011,0,0,1-8-8V336H488Zm0-32H24V80a8.011,8.011,0,0,1,8-8H480a8.011,8.011,0,0,1,8,8Z"
            fill="#5c48d3"
          />
          <path
            d="M384,201.38V160a8,8,0,0,0-4.62-7.25l-120-56a7.991,7.991,0,0,0-6.76,0l-120,56a8,8,0,0,0,0,14.5L176,187.49V280a8,8,0,0,0,8,8H328a8,8,0,0,0,8-8V187.49l32-14.93v28.82a24,24,0,1,0,16,0ZM320,272H192V194.96l60.62,28.29a7.991,7.991,0,0,0,6.76,0L320,194.96Zm-64-64.83L154.92,160,256,112.83,357.08,160ZM376,232a8,8,0,1,1,8-8A8.011,8.011,0,0,1,376,232Z"
            fill="#5c48d3"
          />
        </g>
      </g>
    </svg>
  );
};
export default CoursePlatform;
